<template>
  <div class="w-100 h-100">
    <div class="px-6 py-6 contact-info-container d-flex flex-column h-100 border-radius-4">
      <div>
        <span class="heading-6 textPrimary--text">
          {{ companyName }}
        </span>
      </div>
      <div class="contact-info-items-container">
        <div class="contact-info-item pt-4 d-flex align-top">
          <div class="item-icon">
            <VIcon color="textPrimary">
              mdi-map-marker
            </VIcon>
          </div>
          <div class="item-text pl-2">
            <span class="body-2 textPrimary--text">
              {{ address }}
            </span>
          </div>
        </div>
        <div class="contact-info-item pt-4 d-flex align-top">
          <div class="item-icon">
            <VIcon color="textPrimary">
              mdi-email
            </VIcon>
          </div>
          <div class="item-text pl-2">
            <a
              class="body-2 secondary--text dont-break-out"
              :href="`mailto:${email}`"
            >
              {{ email }}
            </a>
          </div>
        </div>
        <div class="contact-info-item pt-4 d-flex align-top">
          <div class="item-icon">
            <VIcon color="textPrimary">
              mdi-phone
            </VIcon>
          </div>
          <div class="item-text pl-2">
            <a
              class="body-2 secondary--text"
              :href="`tel:${phoneNumber}`"
            >
              {{ phoneNumber }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ContactUsContactInfo',
};
</script>

<script setup lang="ts">
defineProps({
  companyName: {
    type: String,
    default: '',
  },
  phoneNumber: {
    type: String,
    default: '',
  },
  email: {
    type: String,
    default: '',
  },
  address: {
    type: String,
    default: '',
  },
});
</script>

<style scoped lang="scss">
.contact-info-container {
  background-color: var(--v-textWhite-base) !important;
}
</style>
